<template>
  <div>
    <Modal class="editBlock contactEdit" v-model="modal" :title="addsure ? '新增联系人' :'编辑联系人'" width="35" footer-hide>
      <div class="bodyfirst">
        <div class="title">基本信息</div>
        <div class="content">
          <Row>
            <Col span="12" class="necessary">
              <div>
                <label>
                  <span>*</span>获得时间
                </label>
                <div class="editInput editDate">
                  <DatePicker type="date" v-model="editDate">
                    <div class slot="suffix">
                      <img src="~assets/img/public/datelinear.png" />
                    </div>
                  </DatePicker>
                </div>
              </div>
            </Col>
            <Col span="12">
              <label>类型</label>
              <Select class="editInput" v-model="editType">
                <Option value="1">客户</Option>
                <Option value="2">合作伙伴</Option>
                <Option value="3">集成商</Option>
                <Option value="4">渠道</Option>
                <Option value="5">供应商</Option>
                <Option value="6">分销商</Option>
                <Option value="7">其他</Option>
              </Select>
            </Col>
          </Row>
          <Row class="editShare">
            <label>共享</label>
            <RadioGroup class="editInput" v-model="editShare">
              <Radio label="所有人">所有人</Radio>
              <Radio label="不共享">
                不共享
                <span class="shareSpan">（仅创建人和直属上级可见）</span>
              </Radio>
            </RadioGroup>
          </Row>
        </div>
      </div>
      <div class="bodytwice">
        <div class="title">联系人信息</div>
        <div class="content">
          <Row>
            <Col span="12" class="necessary">
              <label>
                <span>*</span>姓名
              </label>
              <Input class="editInput" v-model="editName" type="text"></Input>
            </Col>
            <Col span="12" class="editSex">
              <label>性别</label>
              <RadioGroup class="editInput" v-model="editSex">
                <Radio label="男性"></Radio>
                <Radio label="女性"></Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <label>生日</label>
              <DatePicker class="editInput" v-model="editBirthday" type="date"></DatePicker>
            </Col>
            <Col span="12">
              <label>邮件</label>
              <Input class="editInput" v-model="editEmail" type="text"></Input>
            </Col>
          </Row>
          <Row>
            <Col span="12">
              <label>电话</label>
              <Input class="editInput" v-model="editTelephone" type="text"></Input>
            </Col>
            <Col span="12">
              <label>手机</label>
              <Input class="editInput" v-model="editCellphone" type="text"></Input>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>地址</label>
              <Select class="editInput address" v-model="editProvince">
                <Option value="1">1</Option>
              </Select>
              <Select class="editInput address" v-model="editDistrict">
                <Option value="1">1</Option>
              </Select>
              <Input class="editInput lastAddress" v-model="editAddress"></Input>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>说明</label>
              <Input class="editInput pus" v-model="editPus"></Input>
            </Col>
          </Row>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div v-if="editStatus" class="btn" @click="editConfirm">储存</div>
          <div v-if="addsure" class="btn" @click="addConfirm">提交</div>
          <div class="btn" @click="reset">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "ModalForm",
  props: ["editStatus", "addsure", "formModal","obj"],
  data () {
    return {
      editDate: '',
      editType: '',
      editShare: '',
      editName: '',
      editSex: '',
      editBirthday: '',
      editEmail: '',
      editTelephone: '',
      editCellphone: '',
      editProvince: '',
      editDistrict: '',
      editAddress: '',
      editPus: '',
    }
  },
  computed: {
    modal: {
      get () {
        return this.formModal
      },
      set (val) {
        this.$emit("update:formModal",val)
        this.$emit("update:editStatus",false)
        this.$emit("update:addsure",false)
        this.reset()
      }
    }
  },
  mounted () {
  },
  methods: {
    //提交确定
    addConfirm(){
      this.modal = false
    },
    //编辑确定
    editConfirm () {
      this.modal = false
    },

    //reset
    reset () {
      this.editDate = ''
      this.editType = ''
      this.editShare = ''
      this.editName = ''
      this.editSex = ''
      this.editBirthday = ''
      this.editEmail = ''
      this.editTelephone = ''
      this.editCellphone = ''
      this.editProvince = ''
      this.editDistrict = ''
      this.editAddress = ''
      this.editPus = ''
      
    }
  }
}
</script>
<style lang="less">
.editBlock.contactEdit {
  .ivu-modal-body {
    .ivu-col {
      &.necessary {
        margin-left: -8px;
        span {
          color: var(--main-red);
        }
      }
      &.editSex {
        padding-left: 7px;
        padding-top: 5px;
      }
    }
    .editShare {
      padding-left: 20px;
      .ivu-radio-wrapper:first-of-type {
        margin-right: 20px;
      }
      .shareSpan {
        font-size: 12px;
        color: var(--content-black);
        display: inline-block;
        transform: translateY(1px);
      }
    }
    .editInput {
      width: 70%;
      margin-top: 6px;
      margin-left: 10px;
      margin-bottom: 9px;
      &.editDate {
        display: inline-flex;
      }
      &.address {
        width: 20%;
        display: inline-block;
      }
      &.lastAddress {
        width: 42%;
        display: inline-block;
      }
      &.pus {
        width: 85%;
      }
    }
    .ivu-input-suffix {
      background-color: #f8f8f8;
      border: solid 1px var(--border-black);
      .ivu-icon-ios-calendar-outline:before {
        width: 17px;
        height: 16px;
        background-image: url("~assets/img/public/datelinear.png");
        background-repeat: no-repeat;
      }
    }
  }
}
</style>